<template>
  <div
    class="box">
    <span class="title">Policy Info</span>
    <div class="flex">
      <span
        v-tooltip="prePolicyInfo.company_name"
        class="icon icon-content"
      >
        <img
          :src="getOptionData('companySmallIcon', prePolicyInfo.company_id).logo? getOptionData('companySmallIcon', detailData.company_id).logo: prePolicyInfo.company_logo"
        >
      </span>
      <span
        v-tooltip="prePolicyInfo.class_language"
        class="icon icon-content"
      >
        <font-awesome-icon
          v-if="prePolicyInfo.class_id"
          :icon="getOptionName('iconOptions', prePolicyInfo.class_id)" />
      </span>
      <router-link
        :to="viewPolicy(prePolicyInfo)"
        class="plan-name hand text-decoration-none">{{ prePolicyInfo.plan }}</router-link>
    </div>
    <ul>
      <li>
        <span>Created</span>
        <span>{{ prePolicyInfo.created_date }}</span>
      </li>
      <li>
        <span>Policy No.</span>
        <span>{{ prePolicyInfo.pcy_no }}</span>
      </li>
      <li>
        <span>Insured Period</span>
        <span>{{ prePolicyInfo.period_date }}</span>
      </li>
      <li>
        <span>Status</span>
        <span class="color-green">{{ prePolicyInfo.status_language }}</span>
      </li>
      <li>
        <span>Auto Renew</span>
        <span
          :class="{'color-green':pre_auto_renewal_info.auto_on}">{{pre_auto_renewal_info.auto_on?'ON':'OFF'}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'right-policy-info',
  mixins: [MixinOptions],
  props:{
    isSMEProduct:{
      type:Boolean,
      default:false
    },
    detailData:{
      type:Object,
      default:()=>({})
    },
    prePolicyInfo:{
      type:Object,
      default:()=>({})
    },
  },
  computed:{
    pre_auto_renewal_info(){
      let {pre_auto_renewal_info} = this.detailData||{}
      return pre_auto_renewal_info||{}
    }
  },
  methods:{
    viewPolicy(item){
      const { order_id, product_id,pcy_id } = item
      let {sme_versions} = this.$route.query
      return({
        path: product_id > 50? '/records/policy/manual/detail': '/records/policy/detail',
        query: {
          id: order_id,
          product_id,
          pcy_id,
          sme_versions
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box{
  padding: 29.5px 0;
  border-bottom: 1px solid #D1D5DA;
  .status{
    color: #68C23A
  }
  .title {
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 5px;
    font-size: 14px;
    font-weight: bold;
  }
  .icon{
    margin-right: 15px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
  }
  .plan-name{
    color: #0366D6;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
  }
  .blue{
    color: #0366D6;
  }
  ul {
    margin-top: 15px;
    li {
      display: flex;
      padding: 5px;
      list-style: none;
      color: #606266;
      font-size: 12px;
      line-height: 14px;
      span {
        flex: 1;
        .tag{
          .span-tag{
            display: inline-block;
            border-radius: 100px;
            height: 18px;
            background: #FFFFFF;
            padding: 0px 8px;
            font-weight: 600;
            font-size: 12px;
            line-height: 18px;
            box-sizing: content-box;
            white-space: nowrap;
            margin-bottom: 4px;
            &.verified{
              border: 1px solid #22863a;
              color: #22863a;
            }
            &.pending_verify{
              border: 1px solid #dbab09;
              color: #dbab09;
            }
            &.not_verify{
              border: 1px solid #d73a49;
              color: #d73a49;
            }
            &.unread-uplod{
              border: 1px solid #f66a0a;
              color: #c24e00;
            }
            &.professional-status, &.coupon-status, &.discount-status{
              border: 1px solid #0366d6;
              color: #0366d6;
            }
            &.green {
              background: #DCFFE4;
              color: #28A745;
              border: none;
            }
            &.orange {
              background-color:#FFF5B1 ;
              color:  #B08800;
              border: none;
            }
            &.red {
              background: #D73A49;
              color:#fff;
              border: none;
            }
          }
        }
      }

      span:first-child {
        font-weight: bold;
      }
    }
    li:first-child {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    li:last-child {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    margin-bottom: 15px;
  }
}
</style>
